export interface IUser {
  userID: number;
  firstName: string;
  lastName: string;
  eMail: string;
  photoUrl: string;
  isAdmin: boolean;
  disabled: boolean;
  note: string;
  lastLogin: Date | null;
  registered: Date;
  apiKey: string | null;
  verified: boolean;

}

export class User implements IUser {
  userID = 0;
  firstName = "";
  lastName = "";
  eMail = "";
  photoUrl = "";
  isAdmin = false;
  disabled = false;
  note = "";
  apiKey = null;
  lastLogin: Date | null = null;
  registered!: Date;
  verified = false;

  get name() {

    if (!this.firstName) {
      return this.lastName;
    }
    return this.firstName + ' ' + this.lastName;
  }

}
export interface UserSettings {
  debug?: boolean;
}

export interface CurrentUser {
  userID: number;
  sessionID: string;
  name: string;
  isAdmin: boolean;
  uniqueID: string;
}

export class Employee extends User {
  sendNotifications?: boolean;
  referenceId?: string;
  pin?: string;
  allowMultipleSessions?: boolean;

  /**
   * Rola zaposlenog u opsegu u kom se uređuje (lokal ili organizacija).
   * `0` skida rolu; `undefined` znači „ne diraj rolu" — server tako razlikuje stari klijent,
   * koji polje uopšte ne šalje, od namernog skidanja.
   */
  roleID?: number;
}

/** Lokal u kom je zaposleni zaveden. */
export interface EmployeeCompany {
  companyID: number;
  name: string;
}

/**
 * Zaposleni na spisku organizacije. Spisak je UNIJA: pored onih koji imaju org zapis, pokazuje i one
 * koji su zavedeni samo u nekom lokalu organizacije — zatečeni klijenti upisuju samo zaposlenje u
 * lokalu, pa bi bez toga velik deo ljudi bio nevidljiv na org nivou.
 */
export class OrganizationEmployee extends Employee {
  /**
   * Lokali u kojima je zaposlen. PRAZNO znači da je vezan samo za org nivo — zasebna oznaka za to
   * ne postoji jer se iz praznog spiska ionako vidi.
   */
  companies?: EmployeeCompany[];

  /**
   * Naziv org role, ako je ima. `roleID` je nasleđen iz `Employee` — tamo nosi vrednost koja se
   * ŠALJE pri snimanju, a ovde onu koju je server VRATIO; obe su isti podatak, pa se ne dupliraju.
   */
  roleName?: string | null;
}

export interface Waiter {
  referenceID: string;
  iD: number | null;
  name: string;
}
